import { Tag } from 'antd';

interface StatusTagProps {
  status: 'active' | 'inactive' | 'pending' | 'error';
  label: string;
  className?: string;
}

const statusColorMap = {
  active: 'green',
  inactive: 'red',
  pending: 'orange',
  error: 'red',
} as const;

/**
 * Colored status tag with predefined colors
 * @param status - Status type (determines color)
 * @param label - Display text
 * @param className - Additional CSS classes
 */
const StatusTag = ({ status, label, className = '' }: StatusTagProps) => {
  return (
    <Tag color={statusColorMap[status]} className={className}>
      {label}
    </Tag>
  );
};

export default StatusTag;
